import PropTypes from "prop-types";
import React, { useEffect } from "react";
import Resource from "./Resource";

const Resources = ({
  sections,
  onItemClick,
  sectionRefs,
  scrollToSectionByHash
}) => {
  useEffect(() => {
    scrollToSectionByHash();
  }, []);

  return sections.map((section, i) => (
    <Resource
      sectionRefs={sectionRefs}
      key={i}
      section={section}
      onItemClick={onItemClick}
    />
  ));
};

export default Resources;

Resources.propTypes = {
  onItemClick: PropTypes.func,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * The name of the resource section
       */
      name: PropTypes.string,
      /**
       * The resources within the resource section
       */
      items: PropTypes.arrayOf(
        PropTypes.shape({
          /**
           * The name of the resource
           */
          name: PropTypes.string,

          /**
           * The type of the resource
           */
          type: PropTypes.string
        })
      )
    })
  ),
  sectionRefs: PropTypes.array,
  scrollToSectionByHash: PropTypes.func
};
